<template>
  <div class="manage-events-container">
    <h4>{{ userRole === 'admin' ? 'Gestionează Toate Evenimentele' : 'Gestionează Evenimentele Tale' }}</h4>
    
    <div v-if="loading">Se încarcă evenimentele...</div>
    <div v-if="error" class="error">{{ error }}</div>
    <div class="table-responsive-wrapper">
        <table v-if="events.length > 0" class="events-table">
          <thead>
            <tr>
              <th>Titlu</th>
              <th>Dată Început</th>
              <th>Cod</th>
              <th>Acțiuni</th>
              <th>Cod QR</th> </tr>
          </thead>
          <tbody>
            <tr v-for="event in events" :key="event.id">
              <td>{{ event.title }}</td>
              <td>{{ formatData(event.start_time) }}</td>
              <td>{{ event.confirmation_code }}</td>
              <td class="actions">
                <button @click="handleEdit(event)" class="edit-btn">Editează</button>
                <button @click="handleDelete(event.id)" class="delete-btn">Șterge</button>
              </td>
              <td>
                <button @click="showQrCode(event)" class="qr-btn">
                  Afișează
                </button>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
    <p v-if="!loading && events.length === 0">Nu există evenimente de administrat.</p>

    <QrModal 
      v-if="isQrModalVisible"
      :qrValue="selectedEventForQr.confirmation_code"
      :title="selectedEventForQr.title"
      @close="closeQrModal"
    />
  </div>
</template>

<script setup>
// AM ADĂUGAT 'ref' ȘI 'QrModal'
import { ref, onMounted, defineEmits, defineExpose } from 'vue';
import QrModal from './QrModal.vue'; 
import apiClient from '@/api.js';

const events = ref([]);
const loading = ref(true);
const error = ref('');
const userRole = ref(''); 

const emit = defineEmits(['edit-event']);

// NOU: STAREA PENTRU MODAL
const isQrModalVisible = ref(false);
const selectedEventForQr = ref(null);

// NOU: FUNCȚII PENTRU MODAL
const showQrCode = (event) => {
  selectedEventForQr.value = event;
  isQrModalVisible.value = true;
};
const closeQrModal = () => {
  isQrModalVisible.value = false;
  selectedEventForQr.value = null;
};
// ---

const formatData = (isoString) => {
  if (!isoString) return 'N/A';
  return new Date(isoString).toLocaleString('ro-RO', {
    dateStyle: 'short',
    timeStyle: 'short'
  });
};

const fetchManagedEvents = async () => {
  loading.value = true;
  error.value = ''; 
  try {
    if (!userRole.value) { 
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData) {
        userRole.value = userData.role;
      } else {
        throw new Error('Utilizator nelogat.');
      }
    }

    let response;
    if (userRole.value === 'admin') {
      console.log("ManageEvents: Se încarcă /api/admin/events/all (Admin)");
      response = await apiClient.get('/admin/events/all');
    } else if (userRole.value === 'coordonator') {
      console.log("ManageEvents: Se încarcă /api/events/my-created (Coordonator)");
      response = await apiClient.get('/events/my-created');
    } else {
      throw new Error('Rol neautorizat pentru a vedea evenimentele.');
    }
    
    events.value = response.data;

  } catch (err) {
    console.error("Eroare la preluarea evenimentelor de management:", err);
    error.value = 'Nu am putut încărca evenimentele de management.';
  } finally {
    loading.value = false;
  }
};

onMounted(fetchManagedEvents);

defineExpose({
  refresh: fetchManagedEvents
});

const handleDelete = async (eventId) => {
  if (!window.confirm('Ești sigur că vrei să ștergi acest eveniment? Această acțiune este ireversibilă și va șterge și toate înscrierile!')) {
    return;
  }
  try {
    await apiClient.delete(`/events/${eventId}`); 
    fetchManagedEvents(); 
  } catch (err) {
    console.error("Eroare la ștergerea evenimentului:", err);
    alert('A apărut o eroare la ștergere.');
  }
};

const handleEdit = (event) => {
  emit('edit-event', { ...event });
};
</script>

<style scoped>
/* Stilurile tale existente */
.manage-events-container {
  margin-top: 20px;
}
h4 {
  font-size: 1.2em;
  color: #333;
}
.events-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}
.events-table th, .events-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-size: 0.9em;
  vertical-align: middle; /* Aliniere verticală */
}
.events-table th {
  background-color: #f2f2f2;
}
.actions {
  display: flex;
  gap: 5px;
}
.actions button {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 0.8em;
}
.edit-btn {
  background-color: #ffc107; /* Galben */
}
.delete-btn {
  background-color: #dc3545; /* Roșu */
}
.error {
  color: red;
}

/* NOU: STIL PENTRU BUTONUL QR */
.qr-btn {
  background-color: #0E3035; /* Albastru Închis */
  color: white;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8em;
}
.qr-btn:hover {
  opacity: 0.8;
}
/* --- */

@media (max-width: 768px) {
  .table-responsive-wrapper {
    width: 100%;
    overflow-x: auto; 
    -webkit-overflow-scrolling: touch; 
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  .events-table {
    min-width: 700px; 
  }
}
</style>